import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import SettingsApplicationsOutlinedIcon from "@mui/icons-material/SettingsApplicationsOutlined";
import Collapse from "@mui/material/Collapse";
import ListItemText from "@mui/material/ListItemText";
import ExpandMore from "@mui/icons-material/ExpandMore";
import NavigateNext from "@mui/icons-material/NavigateNext";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import PrintIcon from "@mui/icons-material/Print";
import FindInPageOutlinedIcon from "@mui/icons-material/FindInPageOutlined";
import { Divider, List, ListItemIcon, ListSubheader } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import VerifyPermission from "../../utils/verifyPermission";
import MessageNotifications from "../../utils/messageNotifications";

export default function NavLateralMaster({ classes }) {
  const { id, provincia } = useParams();
  const url = useLocation();
  const user = useSelector((state) => state.account.user);
  const navegate = useNavigate();

  const [openEstabelecimento, setOpenEstabelecimento] = React.useState(false);
  const [openEmpresa, setOpenEmpresa] = React.useState(false);
  const [openRelatorio, setOpenRelatorio] = React.useState(false);
  const [openRepresentante, setOpenRepresentante] = React.useState(false);
  const [openDT, setOpenDT] = React.useState(false);
  const [openAgenda, setOpenAgenda] = React.useState(false);
  const [openGestAdmin, setOPenGestAdmin] = React.useState(false);
  const [openCentralImpressao, setOPenCentralImpressao] = React.useState(false);
  const [openGestSite, setOpenGestSite] = React.useState(false);
  const [openGestMedicamentos, setOpenGestMedicamentos] = React.useState(false);

  const selectOpen = (event) => {
    setOpenEstabelecimento(event === "estabelecimento" && !openEstabelecimento);
    setOpenEmpresa(event === "empresa" && !openEmpresa);
    setOpenRepresentante(event === "representante" && !openRepresentante);
    setOpenDT(event === "DT" && !openDT);
    setOpenAgenda(event === "agenda" && !openAgenda);
    setOPenGestAdmin(event === "gestAdmin" && !openGestAdmin);
    setOPenCentralImpressao(event === "centralImpressao" && !openCentralImpressao);
    setOpenGestSite(event === "getSite" && !openGestSite);
    setOpenGestMedicamentos(event === "gestMedicamentos" && !openGestMedicamentos);
    setOpenRelatorio(event === "relatorio" && !openRelatorio);
  };

  return (
    <>
      <List>

        <VerifyPermission permissions={user?.permissions} permission={'Dashboard'}>
          <div className={`${classes.hoverListItem} ${(url.pathname === '/admin/dashboard' || url.pathname === `/admin/provincia/${provincia}`) && classes.ondeEstou}`}>
            <ListItemButton onClick={() => { navegate('/admin/dashboard') }}>
              <img src="/icones/Dashboard.svg" width={30} style={{ marginRight: 15 }} alt="img" />
              Dashboard
            </ListItemButton>
          </div>
        </VerifyPermission>

        {/* <VerifyPermission permissions={user?.permissions} permission={'Menu'}> */}
        <div className={`${classes.hoverListItem} ${url.pathname === '/admin/menu' && classes.ondeEstou}`}>
          <ListItemButton onClick={() => { navegate('/admin/menu') }}>
            <img src="/icones/Menu.svg" width={30} style={{ marginRight: 15 }} alt="img" />
            Menu
          </ListItemButton>
        </div>
        {/* </VerifyPermission> */}

        <VerifyPermission permissions={user?.permissions} permission={'Chat'}>
          <div className={`${classes.hoverListItem} ${url.pathname === '/admin/cip' && classes.ondeEstou}`}>
            <ListItemButton disabled onClick={() => { navegate('/admin/cip') }}>
              <ListItemIcon className="text-white">
                <MessageNotifications />
              </ListItemIcon>
              Chat
            </ListItemButton>
          </div>
        </VerifyPermission>

        <div className={`${classes.hoverListItem} ${(url.pathname === "/admin/dlif/relatorios/geral" || url.pathname === "/autorizacoes-de-exercicio-emitidas/geral" || url.pathname === "/admin/dlif/relatorios/importacao") && classes.ondeEstou}`}>
          <ListItemButton onClick={() => selectOpen("relatorio")}>
            <img
              src="/icones/relatorio.svg"
              width={35}
              style={{ marginRight: 15 }}
              alt=""
            />
            <ListItemText disableTypography primary="Relatórios / Arquivos" />
            {openRelatorio ? <ExpandMore /> : <NavigateNext />}
          </ListItemButton>
        </div>

        <Collapse in={openRelatorio} timeout="auto" unmountOnExit>
          <VerifyPermission permissions={user?.permissions} permission={'relatoriosLicenciamento'}>
            <List component="div" sx={{ background: "#24274a" }} subheader={<ListSubheader sx={{ background: 'none', color: "#ffff" }} >LICENCIAMENTO</ListSubheader>}>

              <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/admin/dlif/relatorios/geral")}>
                Relatório de Licenciamento
              </ListItemButton>

              <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/autorizacoes-de-exercicio-emitidas/geral?page=1")}>
                Autorização Emitida
              </ListItemButton>
            </List>

            <List component="div" sx={{ background: "#24274a" }} subheader={<ListSubheader sx={{ background: 'none', color: "#ffff" }} >PRODUTO CONTROLADO</ListSubheader>}>
              <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Aprovado")}>
                Certificado Emitido
              </ListItemButton>
            </List>
          </VerifyPermission>


          <VerifyPermission permissions={user?.permissions} permission={'relatoriosImportacao'}>
            <List component="div" sx={{ background: "#24274a" }} subheader={<ListSubheader sx={{ background: 'none', color: "#ffff" }} >IMPORTAÇÃO</ListSubheader>}>
              <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/admin/dmts/solicitacoes-de-importacao/produtos/N%C3%A3o%20Controlados/Aprovado")}>
                Autorização Emitida
              </ListItemButton>

              <VerifyPermission permissions={user?.permissions} permission={'Relatório'}>
                <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/admin/dlif/relatorios/importacao?page=1")}>
                  Relatório de Importação e Desafaldengamento
                </ListItemButton>
              </VerifyPermission>
            </List>
          </VerifyPermission>



          <VerifyPermission permissions={user?.permissions} permission={'relatoriosDesalfandegamento'}>
            <List component="div" sx={{ background: "#24274a" }} subheader={<ListSubheader sx={{ background: 'none', color: "#ffff" }} >DESALFANDEGAMENTO</ListSubheader>}>
              <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Aprovado")}>
                Declaração Emitida
              </ListItemButton>
            </List>
          </VerifyPermission>


          <VerifyPermission permissions={user?.permissions} permission={'relatoriosExpediente'}>
            <List component="div" sx={{ background: "#24274a" }} subheader={<ListSubheader sx={{ background: 'none', color: "#ffff" }} >EXPEDIENTE</ListSubheader>}>
              <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/admin/dadg/expediente/saidas?page=1")}>
                Arquivos
              </ListItemButton>
            </List>
          </VerifyPermission>


          <VerifyPermission permissions={user?.permissions} permission={'relatoriosControloQualidade'}>
            <List component="div" sx={{ background: "#24274a" }} subheader={<ListSubheader sx={{ background: 'none', color: "#ffff" }} >CONTROLO DE QUALIDADE</ListSubheader>}>
              <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/admin/dcqmts/solicitacoes-de-analise/Aprovado")}>
                Certificado e Autorização Emitida
              </ListItemButton>
            </List>
          </VerifyPermission>

          <VerifyPermission permissions={user?.permissions} permission={'relatoriosFarmacovigilancia'}>
            <List component="div" sx={{ background: "#24274a" }} subheader={<ListSubheader sx={{ background: 'none', color: "#ffff" }} >FARMACOVIGILÂNCIA</ListSubheader>}>
              <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/admin/farmacovigilancia/notificacoes/Director%20Geral")}>
                Arquivos
              </ListItemButton>
            </List>
          </VerifyPermission>


          <VerifyPermission permissions={user?.permissions} permission={'relatoriosMedicamentos'}>
            <List component="div" sx={{ background: "#24274a" }} subheader={<ListSubheader sx={{ background: 'none', color: "#ffff" }} >MEDICAMENTOS</ListSubheader>}>
              <ListItemButton sx={{ marginLeft: 2 }} onClick={() => navegate("/admin/tabela-geral-medicamentos?page=1")}>
                Registos
              </ListItemButton>
            </List>
          </VerifyPermission>

        </Collapse>

        <br />
        <Divider style={{ background: "#c43ab9" }} />
        <br />


        <div
          className={`${classes.hoverListItem} ${(url.pathname === "/admin/gestor-estabelecimentos-licenciados" ||
            url.pathname === `/admin/gestor-licenciados/${id}` ||
            url.pathname === `/admin/gestor-licenciados/inspecao/${id}` ||
            url.pathname === `/admin/gestor-licenciados/observacoes/${id}` ||
            url.pathname === `/admin/gestor-licenciados/responsavel-pelo-registo/${id}`) && classes.ondeEstou}`}
        >
          <ListItemButton onClick={() => selectOpen("estabelecimento")}>
            <img
              src="/icones/Estabelecimentos.svg"
              width={35}
              style={{ marginRight: 15 }}
              alt=""
            />
            <ListItemText disableTypography primary="Estabelecimentos" />
            {openEstabelecimento ? <ExpandMore /> : <NavigateNext />}
          </ListItemButton>
        </div>

        <Collapse in={openEstabelecimento} timeout="auto" unmountOnExit>
          <List component="div" style={{ background: "#24274a" }}>

            <VerifyPermission permissions={user?.permissions} permission={'VerEstabelecimentosLicenciados'}>
              <ListItemButton onClick={() => navegate("/admin/gestor-estabelecimentos-licenciados?page=1")}>
                Ver Estabelecimentos Licenciados
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'CategoriasEstabelecimentos'}>
              <ListItemButton onClick={() => navegate("/admin/categorias-de-estabelecimento?page=1")}>
                Categorias de Estabelecimentos
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'CadastrarEstabelecimentos'}>
              <ListItemButton onClick={() => navegate("/admin/cadastro-de-estabelecimento")}>
                Cadastrar Estabelecimentos
              </ListItemButton>
            </VerifyPermission>
          </List>
        </Collapse>

        <div className={`${classes.hoverListItem} ${(url.pathname === "/admin/gestor-empresas" || url.pathname === "/admin/cadastro-empresa") && classes.ondeEstou}`}>
          <ListItemButton onClick={() => selectOpen("empresa")}>
            <img
              src="/icones/Empresa.svg"
              width={35}
              style={{ marginRight: 15 }}
              alt=""
            />
            <ListItemText disableTypography primary="Empresas" />
            {openEmpresa ? <ExpandMore /> : <NavigateNext />}
          </ListItemButton>
        </div>

        <Collapse in={openEmpresa} timeout="auto" unmountOnExit>
          <List component="div" style={{ background: "#24274a" }}>
            <VerifyPermission permissions={user?.permissions} permission={'VerEmpresas'}>
              <ListItemButton onClick={() => navegate("/admin/gestor-empresas?page=1")}>
                Ver Empresas
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'CadastrarEmpresas'}>
              <ListItemButton onClick={() => navegate("/admin/cadastro-empresa")}>
                Cadastrar Empresa
              </ListItemButton>
            </VerifyPermission>
          </List>
        </Collapse>

        <div className={`${classes.hoverListItem} ${(url.pathname === "/admin/gestor-representantes" ||
          url.pathname === "/admin/cadastro-representante") &&
          classes.ondeEstou
          }`}
        >
          <ListItemButton onClick={() => selectOpen("representante")}>
            <img
              src="/icones/Representante.svg"
              width={35}
              style={{ marginRight: 15 }}
              alt=""
            />
            <ListItemText disableTypography primary="Representantes" />
            {openRepresentante ? <ExpandMore /> : <NavigateNext />}
          </ListItemButton>
        </div>

        <Collapse in={openRepresentante} timeout="auto" unmountOnExit>
          <List component="div" style={{ background: "#24274a" }}>
            <VerifyPermission permissions={user?.permissions} permission={'VerRepresentantes'}>
              <ListItemButton onClick={() => navegate("/admin/gestor-representantes?page=1")}>
                Ver Representantes
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'CadastrarRepresentantes'}>
              <ListItemButton onClick={() => navegate("/admin/cadastro-representante")}>
                Cadastrar Representante
              </ListItemButton>
            </VerifyPermission>

            <ListItemButton disabled>Comunicados</ListItemButton>
          </List>
        </Collapse>

        <div className={`${classes.hoverListItem} ${(url.pathname === "/admin/gestor-director-tecnicos" ||
          url.pathname === "/admin/cadastro-director-tecnico" ||
          url.pathname === "/admin/categorias-director-tecnico") &&
          classes.ondeEstou
          }`}
        >
          <ListItemButton onClick={() => selectOpen("DT")}>
            <img
              src="/icones/Director_tecnico.svg"
              width={35}
              style={{ marginRight: 15 }}
              alt=""
            />
            <ListItemText disableTypography primary="Directores Técnicos" />
            {openDT ? <ExpandMore /> : <NavigateNext />}
          </ListItemButton>
        </div>

        <Collapse in={openDT} timeout="auto" unmountOnExit>
          <List component="div" style={{ background: "#24274a" }}>
            <VerifyPermission permissions={user?.permissions} permission={'VerDirectoresTécnicos'}>
              <ListItemButton onClick={() => navegate("/admin/gestor-director-tecnicos?page=1")} >
                Ver Directores Técnicos
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'CadastrarDirectorTécnico'}>
              <ListItemButton onClick={() => navegate("/admin/cadastro-director-tecnico")}>
                Cadastrar Directores Técnicos
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'CategoriasdeDirectorTécnico'}>
              <ListItemButton onClick={() => navegate("/admin/categorias-director-tecnico?page=1")}>
                Categorias Directores Técnicos
              </ListItemButton>
            </VerifyPermission>

            <ListItemButton disabled>Comunicados</ListItemButton>
          </List>
        </Collapse>

        <VerifyPermission permissions={user?.permissions} permission={'CentralImpressão'}>
          <>
            <div
              className={`${classes.hoverListItem} ${url.pathname === "/admin/central-impressao/qrcode" &&
                classes.ondeEstou
                }`}
            >
              <ListItemButton onClick={() => selectOpen("centralImpressao")}>
                {/* <img src="/icones/Director_tecnico.svg" width={35} style={{ marginRight: 15 }} alt="" /> */}
                <PrintIcon style={{ fontSize: 30, marginRight: 15 }} />
                <ListItemText
                  disableTypography
                  primary="Central de impressão"
                />
                {openCentralImpressao ? <ExpandMore /> : <NavigateNext />}
              </ListItemButton>
            </div>
            <Collapse in={openCentralImpressao} timeout="auto" unmountOnExit>
              <List component="div" style={{ background: "#24274a" }}>
                <a
                  style={{ textDecoration: "none", color: "#fff" }}
                  href="/admin/central-impressao/qrcode"
                  target="_blank"
                >
                  {/* onClick={() => navegate('/admin/central-impressao/qrcode')} */}
                  <ListItemButton>QRcode export</ListItemButton>
                </a>
              </List>
            </Collapse>
          </>
        </VerifyPermission>
      </List>

      <br />
      <Divider style={{ background: "#c43ab9" }} />
      <br />

      <List>
        <div className={`${classes.hoverListItem} ${(url.pathname === "/admin/gestor-agenda" ||
          url.pathname === "/admin/create-agenda" ||
          url.pathname === "/admin/agendas-marcadas") &&
          classes.ondeEstou}`}>
          <ListItemButton onClick={() => selectOpen("agenda")}>
            <img
              src="/icones/Agenda.svg"
              width={35}
              style={{ marginRight: 15 }}
              alt=""
            />
            <ListItemText disableTypography primary="Agenda" />
            {openAgenda ? <ExpandMore /> : <NavigateNext />}
          </ListItemButton>
        </div>

        <Collapse in={openAgenda} timeout="auto" unmountOnExit>
          <List component="div" style={{ background: "#24274a" }}>
            <VerifyPermission permissions={user?.permissions} permission={'CriarAgenda'}>
              <ListItemButton onClick={() => navegate("/admin/create-agenda")}>
                Cria Agenda
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'VerAgendasDisponiveis'}>
              <ListItemButton onClick={() => navegate("/admin/gestor-agenda?page=1")}>
                Agendas Disponíveis
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'VerAgendasMarcadas'}>
              <ListItemButton onClick={() => navegate("/admin/agendas-marcadas?page=1")}>
                Agendas Marcadas
              </ListItemButton>
            </VerifyPermission>
          </List>
        </Collapse>

        <div
          className={`${classes.hoverListItem} ${(url.pathname === "/admin/gestor-site" ||
            url.pathname === "/admin/gestor-banner" ||
            url.pathname === "/admin/gestor-noticias") &&
            classes.ondeEstou
            }`}
        >
          <ListItemButton onClick={() => selectOpen("getSite")}>
            <img
              src="/icones/Noticias.svg"
              width={35}
              style={{ marginRight: 15 }}
              alt=""
            />
            <ListItemText disableTypography primary="Gerenciador do site" />
            {openGestSite ? <ExpandMore /> : <NavigateNext />}
          </ListItemButton>
        </div>

        <Collapse in={openGestSite} timeout="auto" unmountOnExit>
          <List component="div" style={{ background: "#24274a" }}>

            <VerifyPermission permissions={user?.permissions} permission={'GestãoBanner'}>
              <ListItemButton onClick={() => navegate("/admin/gestor-banner")}>
                Gestão do Banner
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'GestãoNoticias'}>
              <ListItemButton onClick={() => { navegate("/admin/gestor-noticias"); }}>
                Gestão de Notícias
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'GestãoDocumentos'}>
              <ListItemButton onClick={() => { navegate("/admin/gestor-docs"); }}>
                Gestão de Documentos
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'GestãoInformaçõesSite'}>
              <ListItemButton onClick={() => navegate("/admin/gestor-site")}>
                Gestão de Informações do Site
              </ListItemButton>
            </VerifyPermission>

            <VerifyPermission permissions={user?.permissions} permission={'GestãoArgitosCiêntifico'}>
              <ListItemButton onClick={() => navegate("/admin/gestor-artigos-cientificos")}>
                Gestão de Artigos Ciêntifico
              </ListItemButton>
            </VerifyPermission>
          </List>
        </Collapse>


        <>
          <div className={`${classes.hoverListItem} ${url.pathname === "/admin/lista-de-usuarios-administradores" && classes.ondeEstou}`}>
            <ListItemButton onClick={() => selectOpen("gestAdmin")}>
              <SettingsApplicationsOutlinedIcon
                style={{ fontSize: 30, marginRight: 15 }}
              />
              <ListItemText disableTypography primary="Gerenciador de admin" />
              {openGestAdmin ? <ExpandMore /> : <NavigateNext />}
            </ListItemButton>
          </div>

          <Collapse in={openGestAdmin} timeout="auto" unmountOnExit>
            <List component="div" style={{ background: "#24274a" }}>

              <VerifyPermission permissions={user?.permissions} permission={'CadastrarAdministrador'}>
                <ListItemButton onClick={() => navegate("/admin/cadastro-administrador ")}>
                  Cadastrar administrador
                </ListItemButton>
              </VerifyPermission>

              <VerifyPermission permissions={user?.permissions} permission={'VerAdministradores'}>
                <ListItemButton onClick={() => navegate("/admin/lista-de-usuarios-administradores?page=1")}>
                  Ver administradores
                </ListItemButton>
              </VerifyPermission>

              <VerifyPermission permissions={user?.permissions} permission={'ConfigurarDepartamento'}>
                <ListItemButton onClick={() => navegate("/admin/departament-seccao-perfil")}>
                  Departamentos - Secção - Perfil
                </ListItemButton>
              </VerifyPermission>

              <VerifyPermission permissions={user?.permissions} permission={'HistoricosActividades'}>
                <ListItemButton onClick={() => { navegate("/admin/historicos-de-actividades?page=1"); }} >
                  Historicos de actividades
                </ListItemButton>
              </VerifyPermission>

              <VerifyPermission permissions={user?.permissions} permission={'HistoricosLogin'}>
                <ListItemButton onClick={() => { navegate("/admin/historicos-de-login?page=1"); }} >
                  Historicos de login
                </ListItemButton>
              </VerifyPermission>

              <VerifyPermission permissions={user?.permissions} permission={'Gestãoemolumentos'}>
                <ListItemButton onClick={() => navegate("/admin/emolumentos?page=1")}>
                  Emolumentos
                </ListItemButton>
              </VerifyPermission>

            </List>
          </Collapse>
        </>


        <VerifyPermission permissions={user?.permissions} permission={'Access'}>
          <div className={`${classes.hoverListItem} ${url.pathname === "/admin/access-visity" && classes.ondeEstou}`}>
            <ListItemButton onClick={() => { navegate("/admin/access-visity"); }}>
              <FindInPageOutlinedIcon style={{ fontSize: 30, marginRight: 15 }} />
              <ListItemText disableTypography primary="Access" />
            </ListItemButton>
          </div>
        </VerifyPermission>

        <div className={`${classes.hoverListItem} ${url.pathname === "/admin/manual-do-utilizador" && classes.ondeEstou}`}>
          <ListItemButton
            disabled
            onClick={() => { navegate("/admin/manual-do-utilizador"); }}
          >
            {/* <img src="/icones/Noticias.svg" width={35} style={{ marginRight: 15 }} alt="" /> */}
            <AutoStoriesIcon style={{ fontSize: 30, marginRight: 15 }} />
            Manual do utilizador
          </ListItemButton>
        </div>
      </List>


      {/* <VerifyPermission permissions={user?.permissions} permission={'allPermissions'}>
        <div className={`${classes.hoverListItem} ${url.pathname === "/admin/definicoes/sistema" && classes.ondeEstou}`}>
          <ListItemButton onClick={() => { navegate("/admin/definicoes/sistema"); }}>
            <SettingsApplicationsOutlinedIcon style={{ fontSize: 30, marginRight: 15 }} />
            <ListItemText disableTypography primary="Definições de sistema" />
          </ListItemButton>
        </div>
      </VerifyPermission> */}
    </>
  );
}
